import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const LinkfireIngestionHistory = () => {
  const getFilesHistory = params =>
    AuthAxios.get(`${DataApiUrl}/admin/linkfire-ingestion-history`, { params })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const runFileAgain = file_names =>
    AuthAxios.post(`${DataApiUrl}/admin/linkfire-ingestion-history/run-file-again`, { file_names })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  return {
    getFilesHistory,
    runFileAgain,
  };
};

export default LinkfireIngestionHistory;
